export default {

  createControlProductTrace: {
    method: 'post',
    url: '/api/createControlProductTrace'
  },
  createProductInspectCertInfo: {
    method: 'post',
    url: '/api/createProductInspectCertInfo'
  },
  updateProductInspectCertInfo: {
    method: 'put',
    url: '/api/updateProductInspectCertInfo'
  },
  getProductInspectCertInfoList: {
    method: 'get',
    url: '/api/getProductInspectCertInfoList'
  },
  deleteProductInspectCertInfo: {
    method: 'delete',
    url: '/api/deleteProductInspectCertInfo'
  },
  getControlProductTrace: {
    method: 'get',
    url: '/api/getControlProductTrace'
  },
  updateControlProductTrace: {
    method: 'put',
    url: '/api/updateControlProductTrace'
  },
  getPickTrace: {
    method: 'get',
    url: '/api/getPickTrace'
  },
  getFarmWorkTrace: {
    method: 'get',
    url: '/api/getFarmWorkTrace'
  },
  getFarmlandTrace: {
    method: 'get',
    url: '/api/getFarmlandTrace'
  },
  getCompanyTrace: {
    method: 'get',
    url: '/api/getCompanyTrace'
  },
  getInspectReportTrace: {
    method: 'get',
    url: '/api/getInspectReportTrace'
  }
}
